import React from "react";

import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DATA } from "../data/products-data";

import { delay, motion } from "framer-motion";
import {
    containerVariants,
    itemVariants,
    itemVariants2,
    photoVariants,
    photoVariants2,
} from "../variants/variants";

const Products = () => {
    const { t } = useTranslation();
    return (
        <div className="grid grid-cols-10">
            <div className="col-start-2 col-span-8 ">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    exit="exit"
                    variants={containerVariants}
                    className="grid grid-cols-1 md:grid-cols-2  w-full"
                >
                    {DATA.map((product, index) => {
                        return (
                            <>
                                <Link
                                    to={`${product.link}/${product.products[0].link}`}
                                    key={product.id}
                                    className={`col-span-1 aspect-square ${product.colSpan === 1
                                        ? "md:aspect-square"
                                        : "md:aspect-video"
                                        }  md:${product.aspectRatio}  ${product.colSpan === 1 ? "md:col-span-1" : "md:col-span-2"
                                        } h-full w-full flex items-center justify-center relative overflow-hidden group`}
                                >
                                    <div className="text-center text-35 md:text-45 lg::text-65 text-white font-semibold z-50 badoniModaFont transition-all duration-700 group-hover:scale-150 group-hover:translate-y-5">
                                    <div className="">
                                        {(() => {
                                            // Get translation for category
                                            const translatedCategory = t(`products.categories.${product.link}`, { defaultValue: '' });
                                            
                                            // If translation exists, split it; otherwise use original
                                            let displayParts = product.title;
                                            if (translatedCategory) {
                                                // Handle & symbol properly
                                                if (translatedCategory.includes('&')) {
                                                    displayParts = translatedCategory.split('&').map(part => part.trim());
                                                } else {
                                                    displayParts = translatedCategory.split(' ');
                                                }
                                            }
                                            
                                            return displayParts.map((line, lineIndex) => (
                                                <React.Fragment key={lineIndex}>
                                                    <motion.div
                                                        custom={lineIndex + 1}
                                                        initial="hidden"
                                                        whileInView="whileInView"
                                                        exit="exit"
                                                        variants={itemVariants2}
                                                        viewport={{ once: false }}
                                                    >
                                                        {line}
                                                        <br />
                                                    </motion.div>
                                                </React.Fragment>
                                            ));
                                        })()}
                                    </div>
                                    </div>

                                    <div className="group-hover:scale-125 h-full w-full absolute top-0 left-0  transition-all duration-700 ease-in-out">
                                        <motion.img
                                            custom={index}
                                            initial="initial"
                                            whileInView="whileInView"
                                            exit="exit"
                                            variants={photoVariants2}
                                            src={`/images/products/${product.link}/0.jpg`}
                                            alt={product.title.join(" ")}
                                            className="h-full w-full object-cover  "
                                        />
                                    </div>
                                </Link>

                                {/* {product.id === 4 && <Outlet />} */}
                            </>
                        );
                    })}
                </motion.div>
            </div>
        </div>
    );
};

export default Products;
